import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './predictedCloseVolumeCapsulePreview.png';

export const predictedCloseVolumeCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Predicted Close Volume Capsule displays my order leaves as a
                percentage of the predicted market close auction.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            src: chartPreview,
            altText: 'predicted-closing-volume-capsule-chart-preview',
        },
    ],
};
